import Vue from 'vue'
import Vuex from 'vuex'
import VueSweetalert2 from 'vue-sweetalert2';
import CartService from '@/services/cart.service'

Vue.use(Vuex)
Vue.use(VueSweetalert2);

export default new Vuex.Store({
	state: {
    campaign_order: null,
		delivery_type: 'free',
		delivery_price_global: 0,
		step_payment_order: '',
		number_day: new Date().getDay(),
    current_month: new Date().getMonth() + 1,
		menu: [
			{
			title: 'Nosotros',
			items: [
				{ title: 'Historia', route: '/nuestra-historia' },
				{ title: 'Colaboraciones', route: '/colaboraciones' }
			]
			},
			{
			title: 'Productos',
			items: [
				{ title: 'Todos', route: '/lista/productos/todos/t'}
			]
			},
			{
			title: 'Contacto',
			items: [
				{ title: 'Sucursales', route: '/sucursales' }
			]
			}
		],
		cart: {
		discount: '',
			cart_products: []
		},
		is_auth: false,
		user: {
			name: '',
			lastname: '',
			email: '',
			phone: '',
			role: '',
			address: '',
			subscription: null,
			primary_address: null
		},
		new_subscription: {
			flavors: [],
			flavors_ids: [],
			subscription_type: '',
			product: '',
			price: 0.00
		},

		data_home_page: {
			flavors: [],
			categories_flavors: [],
			banners: [],
			home_text: '',
			about_text: '',
      enabled_subscriptions: false,
      on_dcn: null
		},
    select_discount: false,
    amount_discount: 0,
		cart_total: 0
	},
	mutations: {
    SET_DISCOUNT_SELECT(state, data) {
      state.select_discount = data.discount
      state.amount_discount = data.amount_discount
      //state.cart_total = parseFloat(state.cart_total.toFixed(2)) - parseFloat(data.amount_discount)
    },
    SET_PACKAGE_ORDER(state, data) {
      state.campaign_order = data
      localStorage.setItem('campaign_order', JSON.stringify(data))
    },
		SET_DATA_HOME_PAGE(state, data) {
			state.data_home_page.flavors = data.flavors
			state.data_home_page.categories_flavors = data.categories_flavors
			state.data_home_page.banners = data.banners
			data.categories_flavors.forEach(i => {
				state.menu[1].items.push(
					{ title: i.name, route: `/lista/productos/${i.key_}/${i.id}` }
				)
			})
			state.data_home_page.home_text = data.config_general.text_home
			state.data_home_page.about_text = data.config_general.text_about
			state.number_day = data.number_day
      state.current_month = data.current_month
      state.data_home_page.on_dcn = data.config_general.on_dcn
      state.data_home_page.enabled_subscriptions = data.config_general.enabled_subscriptions
		},
		SET_CURRENT_USER(state, user) {
			state.user = user
			state.is_auth = true
		},
		SET_CART(state, cart) {
			state.cart = cart
		},
		SET_ADD_ITEM_CART(state, product) {
			//Se verifica si existe el item en el carrito
			const index_item = state.cart.cart_products.findIndex(
				i => i.product.id === product.product.id
			)

			let item = {}

			if (index_item != -1) {
				state.cart.cart_products[index_item].price = parseFloat(product.price)
				state.cart.cart_products[index_item].subtotal = parseFloat(product.price) * parseInt(product.qty)
				state.cart.cart_products[index_item].variant_id = product.variant_id || 0
				state.cart.cart_products[index_item].quantity = parseInt(product.qty)
				state.cart.cart_products[index_item].option_size = product.option_size

				item = state.cart.cart_products[index_item]
			} else {
        const pr = product.product

				item = {
					id: product.product.id,
					variant_id: product.variant_id || 0,
					price: parseFloat(product.price),
					subtotal: parseFloat(product.price) * parseInt(product.qty),
					option_size: product.option_size,
					quantity: parseInt(product.qty),
					product: {
            id: pr.id,
            name: pr.name,
            price: pr.price,
            slug: pr.slug,
            url_image_flask: pr.url_image_flask
          },
					discount: false,
					text_discount: null
				}
				state.cart.cart_products.push(item)
			}

			localStorage.setItem('cart', JSON.stringify(state.cart))
			if (state.is_auth) CartService.addProductCart(item)
		},
		SET_REMOVE_ITEM_CART(state, product) {
			const item_index = state.cart.cart_products.findIndex(
				i => i.id === product.id
			)
			state.cart.cart_products.splice(item_index, 1)
			//appliedAutomaticDiscount()
			localStorage.setItem('cart', JSON.stringify(state.cart))
		},
		SET_SESSION(state, session) {
			state.is_auth = session
		},
		SET_NEW_SUBSCRIPTION(state, data) {
			state.new_subscription = data
			localStorage.setItem('subscription_selected', JSON.stringify(data))
		},
		SET_TOTAL_CART(state, total) {
			state.cart_total = total
		},
		SET_DELIVERY_PRICE_GLOBAL(state, data) {
			state.delivery_price_global = data
		},
		SET_DELIVERY_TYPE(state, data) {
			state.delivery_type = data
		},
		APPLIED_AUTOMATIC_DISCOUNT(state, { getters }) {

			let number_day = state.number_day
			let condition_discount = getters.automatic_discount

			if (number_day == 2 || number_day == 4) {
				let quantity = 0
				state.cart.cart_products.forEach(i => {
					if (i.option_size.toLowerCase() == condition_discount) {
						quantity += i.quantity
					}
				})

				let num_divider
				if (number_day == 2) num_divider = 2
				if (number_day == 4) num_divider = 3

				//cantidad de productos a aplicarles el descuento
				let quantity_items_applied_discount = parseInt(quantity / num_divider)

				let qty_items_for_discount = 2
				if (number_day == 4) qty_items_for_discount = 3
				if (quantity >= qty_items_for_discount) {

					const products_discount = state.cart.cart_products.filter(el => el.option_size.toLowerCase() == '1/4 litro')
					if (products_discount.length > 1) {
						let count = 0;
						for (let index = 0; index < state.cart.cart_products.length; index++) {
							if (count < quantity_items_applied_discount) {
								const item = state.cart.cart_products[index]
								if (item && item.option_size.toLowerCase() == '1/4 litro') {
									count++
									state.cart.cart_products[index].discount = true
									state.cart.cart_products[index].subtotal = (state.cart.cart_products[index].price * state.cart.cart_products[index].quantity) - state.cart.cart_products[index].price
									state.cart.cart_products[index].text_discount = getters.text_automatic_discount
									if (state.is_auth) CartService.addProductCart(state.cart.cart_products[index])
								}
							}
						}
					} else {
						if (products_discount.length) {
							let index = state.cart.cart_products.findIndex(i => i.id == products_discount[0].id)
							state.cart.cart_products[index].discount = true
							state.cart.cart_products[index].subtotal = (state.cart.cart_products[index].price * state.cart.cart_products[index].quantity) - state.cart.cart_products[index].price * quantity_items_applied_discount
							state.cart.cart_products[index].text_discount = getters.text_automatic_discount
							if (state.is_auth) CartService.addProductCart(state.cart.cart_products[index])
						}

					}

					localStorage.setItem('cart', JSON.stringify(state.cart))
				} else {
          for (let index = 0; index < state.cart.cart_products.length; index++) {
            state.cart.cart_products[index].discount = false
            state.cart.cart_products[index].subtotal = (state.cart.cart_products[index].price * state.cart.cart_products[index].quantity)
            state.cart.cart_products[index].text_discount = ''
            if (state.is_auth) CartService.addProductCart(state.cart.cart_products[index])
          }
        }

			}
		}
	},
	actions: {
    selectDiscount({ commit }, data) {
      commit('SET_DISCOUNT_SELECT', data)
    },
    setPackageOrder({ commit }, data) {
      commit('SET_PACKAGE_ORDER', data)
    },
		setDeliveryTypeGlobal({commit}, data) {
			commit('SET_DELIVERY_TYPE', data)
		},
		setDeliveryPriceGlobal({ commit }, data) {
			commit('SET_DELIVERY_PRICE_GLOBAL', data)
		},
		setTotalCart({ commit }, data) {
			commit('SET_TOTAL_CART', data)
		},
		setNewSubscription({ commit }, data) {
			commit('SET_NEW_SUBSCRIPTION', data)
		},
		setDataHomePage({ commit }, data) {
			commit('SET_DATA_HOME_PAGE', data)
		},
		setUser({ commit }, user) {
			commit('SET_CURRENT_USER', user)
		},
		setSession({ commit }, session) {
			commit('SET_SESSION', session)
		},
		async addItemCart({ commit, getters }, product) {
			commit('SET_ADD_ITEM_CART', product)
			commit('APPLIED_AUTOMATIC_DISCOUNT', { getters })
		},
		async setCart({ commit, state }) {
			try {
				if (state.is_auth) {
					const cart = localStorage.getItem('cart')

					const { data: res } = await CartService.set({
						cart: cart ? JSON.parse(cart) : state.cart
					})
					commit(
						'SET_CART',
						res.data.cart_products ?
							{ cart_products: res.data.cart_products, discount: '' } :
							{ cart_products: [], discount: '' }
					)
					localStorage.setItem('cart', JSON.stringify(state.cart))
				} else {
					const cart = localStorage.getItem('cart')
						commit('SET_CART', cart ? JSON.parse(cart) : { cart_products: [], discount: '' })
					}
			} catch (error) {
				console.log(error)
			}
		},
		async removeItemCart({ commit, state, getters }, product) {
			try {
				if (state.is_auth) {
					await CartService.removeProductCart(product)
					commit('SET_REMOVE_ITEM_CART', product)
				} else {
					commit('SET_REMOVE_ITEM_CART', product)
				}
        commit('APPLIED_AUTOMATIC_DISCOUNT', { getters })
			} catch (error) {
				console.log(error)
			}
		},
		async cleanCart({ commit, state }, href = false) {
			try {

        localStorage.removeItem('cart')
				localStorage.removeItem('order_temporal')
				localStorage.removeItem('option_delivery_mobile')

				if (state.is_auth) {
					const { data: res } = await CartService.cleanCart()
					commit('SET_CART', res.data)
				} else {
					commit('SET_CART', { discount: '', cart_products: [] })
				}

        if (
          window.location.pathname != '/procesar-pago' &&
          window.location.pathname != '/confirmacion-compra'
        ) {
          if (href) {
            location.href = href
          } else {
            location.reload()
          }
        }
			} catch (error) {
				console.log(error)
			}
		}
	},
	getters: {
		total_cart(state) {
			let total = 0
			state.cart.cart_products.forEach(i => {
				total += parseFloat(i.subtotal)
			})
			state.cart_total = parseFloat(total.toFixed(2))
			return parseFloat(total.toFixed(2)) - parseFloat(state.amount_discount)
		},
		quantity_items_cart(state) {
			let quantity = 0
			state.cart.cart_products.forEach(i => {
				quantity += i.quantity
			})
			return quantity
		},
		automatic_discount(state) {
			let discount = ''
			if (state.number_day == 2) discount = '1/2 litro'
			if (state.number_day == 4) discount = '1/4 litro'
			return discount
		},
		text_automatic_discount(state) {
			let text = ''
			if (state.number_day == 2) text = '2 1/2 + 1/4'
			if (state.number_day == 4) text = '2 1/4 + 1/4'
			return text
		}
	},
	modules: {
	}
})
